import { IEltTopIssue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopIssue'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Textarea } from 'core-components/library/inputs'

import styles from './Issues.module.scss'

interface IProps {
  onChange: (field: string, index: number) => (value: string) => void
}

export const getTopIssueColumns = ({ onChange }: IProps): IColumn<IEltTopIssue>[] => {
  return [
    {
      title: getFormedEltTranslation('issue-table-issue'),
      field: 'Issue',
      renderComponent: ({ value, index }) => (
        <Textarea
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('Issue', index)}
          resizable={'none'}
          rows={4}
        />
      ),
    },
    {
      title: getFormedEltTranslation('issue-table-hp-response'),
      field: 'HpProgress',
      renderComponent: ({ value, index }) => (
        <Textarea
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('HpProgress', index)}
          resizable={'none'}
          rows={4}
        />
      ),
    },
  ]
}
